import Main from '../../layouts/Main/Main';
import Portal from '../../components/Portal/Portal';

const Home = () => (
  <Main>
    <Portal />
  </Main>
);

export default Home;
